export default __webpack_public_path__ + "static/media/event-edit.e55aaa76.svg";